import { useTranslations } from 'next-intl';

export default function formatDate (dateInput) {
    const t = useTranslations('month_list');

    const date = new Date(dateInput);
    const YEAR = date?.getFullYear();
    const MONTH_INDEX = date.getMonth();
    const MONTH = t(`${MONTH_INDEX}`);
    const DAY = date.getDate();
    return `${DAY} ${MONTH} ${YEAR}`;
}
